import { createContext, useContext, useState } from "react";

const ErrorModalContext = createContext();

export const ErrorModalProvider = ({ children }) => {
  const [modalState, setModalState] = useState({
    isOpen: false,
    icon: false,
    title: "",
    subtitle: "",
    message: "",
    buttons: [],
  });

  const showError = (config) => {
    let title = config.title || "";
    let subtitle = config.subtitle || "";

    if (subtitle && subtitle.includes("\n")) {
      const [first, ...rest] = subtitle.split(/\n+/);
      title = first.trim();
      subtitle = rest.join(" ").trim();
    }

    setModalState({
      isOpen: true,
      icon: config.icon || false,
      title,
      subtitle,
      message: config.message || "Something went wrong",
      buttons: config.buttons || [],
    });
  };

  const hideError = () => {
    setModalState({
      isOpen: false,
      icon: false,
      title: "",
      subtitle: "",
      message: "",
      buttons: [],
    });
  };

  return (
    <ErrorModalContext.Provider value={{ modalState, showError, hideError }}>
      {children}
    </ErrorModalContext.Provider>
  );
};

export const useErrorModal = () => {
  const context = useContext(ErrorModalContext);
  if (!context) {
    throw new Error("useErrorModal must be used within ErrorModalProvider");
  }
  return context;
};
